import React from 'react';

interface Essay {
    id: string;
    title: string;
    excerpt: string;
    category: string;
    date: Date;
    readTime: string;
    link: string;
}

interface EssayListProps {
    essays: Essay[];
    className?: string;
}

const formatDate = (date: Date): string => {
    return new Date(date).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    });
};

export const EssayList: React.FC<EssayListProps> = ({
    essays,
    className = '',
}) => {
    return (
        <div className={`intellectual-essays ${className}`}>
            {essays.map((essay) => (
                <a
                    key={essay.id}
                    href={essay.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="intellectual-essay"
                >
                    <div className="intellectual-essay-meta">
                        <span className="intellectual-essay-category">{essay.category}</span>
                        <span>•</span>
                        <span>{formatDate(essay.date)}</span>
                        <span>•</span>
                        <span>{essay.readTime}</span>
                    </div>

                    <h3 className="intellectual-essay-title">{essay.title}</h3>
                    <p className="intellectual-essay-excerpt">{essay.excerpt}</p>

                    <span className="intellectual-essay-read">
                        Read Essay →
                    </span>
                </a>
            ))}
        </div>
    );
};

export default EssayList;
